export default __webpack_public_path__ + "static/media/connected.7418a11c.png";